import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/trendelantero/BUJES-DE-LA-PARRILLA-1.png")